import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

import { FLOWS_PROJECT_ROLES_COLUMN_ID } from "../constants";
import FlowsProjectDetailsRolesNameCell from "./NameCell";
import FlowsProjectDetailsRolesDescriptionCell from "./DescriptionCell";
import FlowsProjectDetailsRolesSpaceCell from "./SpaceCell";
import FlowsProjectDetailsRolesRowActionsCell from "./RowActionsCell";

const FLOWS_PROJECT_ROLES_CELLS: TableCellPerColumn<FlowsProjectRoleBindingView> = {
  [FLOWS_PROJECT_ROLES_COLUMN_ID.ROLE]: FlowsProjectDetailsRolesNameCell,
  [FLOWS_PROJECT_ROLES_COLUMN_ID.DESCRIPTION]: FlowsProjectDetailsRolesDescriptionCell,
  [FLOWS_PROJECT_ROLES_COLUMN_ID.SPACE]: FlowsProjectDetailsRolesSpaceCell,
  [FLOWS_PROJECT_ROLES_COLUMN_ID.ROW_ACTIONS]: FlowsProjectDetailsRolesRowActionsCell,
};

export default FLOWS_PROJECT_ROLES_CELLS;
